<template>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 28 28" 
      :width="size" 
      :height="size" 
      class="fancy-loader"
    >
      <defs>
        <!-- Farbverlauf -->
        <linearGradient id="brandGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#E23B3C" /> 
          <stop offset="100%" stop-color="#B22E2F" />
        </linearGradient>
  
        <!-- Glow-Effekt -->
        <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="0.5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>
  
      <g>
        <!-- Pfad 1 (unten/links) -->
        <path class="loader-path path-1" d="M9.54,27.26q1.07-1,2.15-2l2.48-2.29,5-4.54c.82-.76,1.62-1.52,2.41-2.29l.58-.57.55-.57.09-.09c-.27,0-.55.09-.84.15-.5.11-1,.24-1.52.39-1,.29-2.06.65-3.09,1s-2.07.76-3.1,1.17-2.06.84-3.08,1.26l-.8.33-.84.32c-.57.21-1.15.4-1.77.56a10.27,10.27,0,0,1-2,.33,5.58,5.58,0,0,1-1.2-.06,3.76,3.76,0,0,1-1.43-.53,3.13,3.13,0,0,1-1.17-1.35A3.77,3.77,0,0,1,1.6,17,6.63,6.63,0,0,1,2,14.81a11.42,11.42,0,0,1,1.88-3.42A22.28,22.28,0,0,1,6.29,8.73,33.55,33.55,0,0,1,9,6.48c.93-.7,1.9-1.36,2.84-2l2.83-1.84c.94-.61,1.88-1.22,2.8-1.84l.4-.27A14,14,0,0,0,9.54,27.26Z"/>
        
        <!-- Pfad 2 (oben/rechts) -->
        <path class="loader-path path-2" d="M25.81,7.06c-.56.72-1.15,1.42-1.75,2.11H23.3l-.34,0a15.1,15.1,0,0,0-2,.26l.47-.37c1.16-.92,2.28-1.88,3.36-2.9l.45-.45a14.06,14.06,0,0,0-1.64-1.86C22.53,5,21.4,6.17,20.24,7.28s-2.46,2.29-3.72,3.41l-1.13.4c-1.11.41-2.2.82-3.27,1.26S10,13.23,8.93,13.7L8.2,14l0,0c.24-.34.51-.68.79-1l.62-.42,3.22-2.18C14.92,9,17,7.48,19.08,5.92,20.31,5,21.52,4,22.69,3a14,14,0,0,0-2.52-1.59c-.47.39-.93.79-1.41,1.17C17,4,15.16,5.36,13.37,6.7l-.67.5L12,7.7q-.65.5-1.27,1c-.83.7-1.63,1.43-2.37,2.18a19.22,19.22,0,0,0-2,2.37,8.85,8.85,0,0,0-1.29,2.5,2.79,2.79,0,0,0-.08.3c0,.1,0,.2-.06.3a2.33,2.33,0,0,0,0,.5.58.58,0,0,0,0,.09L5,17a2.49,2.49,0,0,0,.48,0,7,7,0,0,0,1.32-.25c.47-.13,1-.29,1.44-.48L9,16l.75-.33c1-.46,2.09-.89,3.15-1.32A65.71,65.71,0,0,1,19.43,12c.57-.16,1.15-.31,1.75-.44a13.65,13.65,0,0,1,1.92-.28,6.54,6.54,0,0,1,1.16,0,4,4,0,0,1,.72.15,3.07,3.07,0,0,1,.89.43,2.57,2.57,0,0,1,.84,1,2.42,2.42,0,0,1,.12.31l0,.15,0,.18a2.61,2.61,0,0,1,0,.65,3.23,3.23,0,0,1-.2.89,4.65,4.65,0,0,1-.28.62,6.91,6.91,0,0,1-.63.94l-.34.4-.18.19-.16.17-.63.63-.63.6c-.85.78-1.7,1.53-2.56,2.27-1.71,1.49-3.45,2.92-5.18,4.36l-3.29,2.71c.37,0,.75.06,1.13.06A14,14,0,0,0,26,6.81Z"/>
      </g>
    </svg>
  </template>
  
  <script setup>
  defineProps({
    size: {
      type: Number,
      default: 80 // Standardgröße ist 80px
    }
  })
  </script>
  
  <style scoped>
  .fancy-loader {
    overflow: visible;
  }
  
  .loader-path {
    fill: url(#brandGrad);
    stroke: url(#brandGrad);
    stroke-width: 0.3;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 150;
    filter: url(#glow);
    animation: drawFill 2.5s ease-in-out infinite;
  }
  
  /* Zeitversatz für die beiden Pfade */
  .path-1 { animation-delay: 0s; }
  .path-2 { animation-delay: 0.15s; }
  
  /* Die eigentliche "Zeichnen und Füllen"-Animation */
  @keyframes drawFill {
    0% {
      stroke-dashoffset: 150;
      fill-opacity: 0;
    }
    40% {
      stroke-dashoffset: 0;
      fill-opacity: 0;
    }
    60% {
      stroke-dashoffset: 0;
      fill-opacity: 1;
    }
    100% {
      stroke-dashoffset: -150;
      fill-opacity: 0;
    }
  }
  </style>